import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const About = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/6196677/pexels-photo-6196677.jpeg"
                alt="Professional Cleaning Team"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-teal-600 text-white p-8 rounded-2xl shadow-xl hidden lg:block">
              <div className="text-4xl font-bold mb-2">5+</div>
              <div className="text-teal-100">Years of Excellence</div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              About Unique Pro Cleaning LLC
            </h2>
            <div className="space-y-4 text-lg text-slate-600 leading-relaxed mb-8">
              <p>
                Unique Pro Cleaning LLC provides dependable residential and commercial cleaning services in Columbus, Ohio.
              </p>
              <p>
                We focus on quality, consistency, and attention to detail to help clients maintain clean, welcoming spaces.
              </p>
              <p>
                Our team of trained professionals takes pride in delivering exceptional results that exceed expectations. Whether it's your home or business, we treat every space with the care and respect it deserves.
              </p>
            </div>

            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg group"
            >
              Get Your Free Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
